<template>
  <v-list
    two-line
    class="mt-2 mb-5">
    <v-layout
      row
      wrap
      class="pa-1 text-xs-center">
      <v-flex
        v-if="!mycoordinates"
        class="primary--text"
        xs12>
        <p>
          <!-- TODO: Text/Translate -->

          Dein derzeitiger Ort:
        </p>
        <p>
          {{ timelineFilter.locationFilter }}
        </p>
      </v-flex>
      <v-flex
        v-else
        class="primary--text"
        xs12>
        <p class="green--text">
          <!-- TODO: Text/Translate -->

          Neu gewählter Ort:
        </p>
        <p>
          {{ timelineFilter.locationFilter }}
        </p>
      </v-flex>
    </v-layout>
    
    <!-- <v-list-tile>
      <v-list-tile-avatar>
        <v-icon>fas fa-map-marker-alt</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-sub-title>
          {{ timelineFilter.locationFilter }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile>
      <v-list-tile-avatar>
        <v-icon>fas fa-route</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-sub-title>
          {{ timelineFilter.distanceFilter }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile> -->
    <!-- Location -->
          

    <v-list-tile class="mt-1">
      <v-text-field
        id="autocomplete"
        v-model="mylocationinput"
        :messages="mylocationinput !== mylocation ? timelineFilter.locationFilter : ''"
        single-line
        solo
        
        :loading="loadingGeolocate"
        :append-icon="mylocationinput ? 'fas fa-times' : 'fas fa-location'"
        prepend-inner-icon="fas fa-map-marker-alt"
        name="Location"
        placeholder="Location"
        type="text"
        
        @focus="initAutocomplete"
        @click:append="clickAppend">
      </v-text-field>
    </v-list-tile>
    <!-- <v-list-tile class="mt-0">
      <v-btn
        v-if="mylocationinput"
        color="green"
        dark
        small
        round
        block
        @click="locationToTimelineFilter">
        <v-icon
          small
          left>
          fas fa-check
        </v-icon>
        Ort wählen
      </v-btn>
    </v-list-tile> -->

    <!-- Distance -->
    <v-list-tile class="mt-2">
      <v-select
        v-model="distance"
        prepend-inner-icon="fas fa-route"
        solo
        :items="distances"
        label="Entfernung"
        dense></v-select>
    </v-list-tile>

    <!-- local -->
    <v-list-tile class="mt-1">
      <v-list-tile-action v-if="isMobile"></v-list-tile-action>
      <v-checkbox
        v-model="local"
        disabled
        color="amber lighten-2"
        hide-details>
        <span slot="label"><strong class="font-italic">Moments</strong> und <strong class="font-italic">Events by Friends</strong> nur im Umkreis anzeigen <br>
          <!-- TODO -->
          <small>(Funktion noch nicht verfügbar)</small>
        </span>
      </v-checkbox>
    </v-list-tile>


    <v-layout class="text-xs-center mt-4 pt-1 px-4">
      <v-flex xs12>
        <article class="font-italic primary--text">
          <!-- TODO: Text/Translate -->

          <p>Wähle deinen Ort!</p>
          <p>
            Zusätzlich kannst du bestimmen in welchem Umkreis dir Events, Moments und Events by Friends angezeigt werden sollen.
          </p>
        </article>
      </v-flex>
    </v-layout>
    <!-- <v-layout class="ma-3">
      {{ mylocationinput }}
      <br>
      {{ mylocation }}
      <br>

      {{ mycoordinates }}
    </v-layout> -->
  </v-list>
</template>


<script>
/* global google */

import { mapState, mapMutations } from 'vuex'



export default {
  data: () => ({
    mylocationinput: '',    
    mylocation: '',    
    mycoordinates: '',

    local: false,

    loadingGeolocate: false,
    autocomplete: null,
    geocoder: null,
    // <!-- TODO: Text/Translate -->
      
    distances: [
      { text: '5 km', value: 5 },
      { text: '10 km', value: 10 },
      { text: '25 km', value: 25 },
      { text: '50 km', value: 50 },
      // { text: '100 km', value: 100 } 
    ]
  }),
  computed: {
    ...mapState({
      timelineFilter: state => state.timeline.timelineFilter,
      user: state => state.user.user,
      isMobile: state => state.isMobile,
    }),

    distance: {
      get() {
        return this.timelineFilter.distanceFilter
      },
      set(value) {
        this.setFilter({ distanceFilter : value })
      }
    }
  },
  
  mounted() {
    var self = this

    self.autocomplete = new google.maps.places.Autocomplete(
      // (document.getElementById('autocomplete'))
      (document.querySelector('#autocomplete'))
      // ,
      // {
      //   // types: [
      //   //   // 'address'
      //   //   'geocode'
      //   // ]
      // }
    )

    self.autocomplete.setFields([
      'formatted_address',
      'geometry',
      'place_id'
    ])

    self.autocomplete.addListener('place_changed', () => {
      let place = self.autocomplete.getPlace()
      self.mylocationinput = place.formatted_address
      self.mylocation = place.formatted_address
      self.mycoordinates = {
        lat: place.geometry.location.lat(), 
        lng: place.geometry.location.lng()
      }

      self.locationToTimelineFilter()
    })
  },
  methods:{
    ...mapMutations([
      'setFilter'
    ]),


    locationToTimelineFilter() {
      if (this.mylocation !== '' && this.mycoordinates !== '') {
        this.setFilter({ locationFilter : this.mylocation })
        this.setFilter({ coordinatesFilter : this.mycoordinates })
      }
      
    },

    clickAppend() {
      if (this.mylocationinput !== '') {
        this.mylocationinput = '' 
      } else {
        this.initGeolocator()
      }
    },
    initGeolocator () {
      this.loadingGeolocate = true
      this.geolocateLocation()
    },

    initAutocomplete () {
      this.geolocateAutocomplete()
    },

    geolocateAutocomplete() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var circle = new google.maps.Circle({
            center: pos,
            radius: position.coords.accuracy
          })
          self.autocomplete.setBounds(circle.getBounds())
        })
      }
    },

    geolocateLocation() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          self.reverseGeocoding(pos)
        })
      } else {
        self.loadingGeolocate = false
      }
    },



    reverseGeocoding(latLng) {
      var self = this

      if (self.geocoder === null) {
        self.geocoder = new google.maps.Geocoder
      } else {

      }

      self.geocoder.geocode({'location': latLng}, function(results, status) {
        if (status === 'OK') {
          self.loadingGeolocate = false

          if (results[0]) {
            self.loadingGeolocate = false

            // var location1 = results[0].formatted_address
            // console.log(results[0].formatted_address)
            self.mylocationinput = results[0].formatted_address
            self.mylocation = results[0].formatted_address
            self.mycoordinates = latLng
            console.log('mycoods', self.mycoordinates)

            self.locationToTimelineFilter()

          } else {
            console.log('No results found')
            self.loadingGeolocate = false

            self.mylocationinput = 'No results found'
            self.mylocation = ''
            self.mycoordinates = ''
          }
        } else {
          console.log('Geocoder failed due to: ' + status)
          self.loadingGeolocate = false
          self.mylocationinput = 'Geocoder failed due to: ' + status
          self.mylocation = ''
          self.mycoordinates = ''
        }
      })
    },

  } 
}
</script>


<style scoped>

</style>
